import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'iniciales'
})
export class InicialesPipe implements PipeTransform {

  transform(dato:string): string {
    let Arr = []
    let newDato = ""

    Arr = dato.trim().split(" ")

    for(let i of Arr){
      newDato += i[0]
    }
    
    return newDato.toLocaleUpperCase();
  }

}
